export const checkinmanual = {
    text1: "Check-in manuale",
    text2: "Inserisci i dati necessari per la registrazione dell'ospite.",
    text3: "Informazioni sull'alloggio",
    text4: "Seleziona l'alloggio *",
    text5: "Informazioni personali",
    text6: "Nome dell'ospite *",
    text7: "Cognome dell'ospite *",
    text8: "Maschio",
    text9: "Femmina",
    text10: "Preferisco non dirlo",
    text11: "Altro",
    text12: "Seleziona il genere *",
    text13: "Data di nascita *",
    text14: "Numero di telefono *",
    text15: "Informazioni sul soggiorno",
    text16: "Le informazioni sul soggiorno sono obbligatorie per procedere con il check-in. Compila tutti i campi.",
    text17: "Da - A",
    text18: "Fino a quale data soggiornerà l'ospite?",
    text19: "Email dell'ospite *",
    text20: "Seleziona il tipo di documento.",
    text21: "Carta d'identità",
    text22: "Passaporto",
    text23: "Tipo di documento",
    text24: "Numero del documento",
    text25: "Inserisci il numero del documento",
    text26: "Scadenza del documento",
    text27: "Scadenza del documento",
    text28: "Continua",
    text29: "Check-in manuale",
    text30: "Inserisci i dati necessari per la registrazione dell'ospite.",
    text31: "Firma del check-in",
    text32: "Firma nel riquadro grigio che vedi sullo schermo",
    text33: "Salva check-in",
    text34: "Processo di check-in completato con successo.",
    text35: "Devi selezionare un alloggio per assegnare il check-in",
    text36: "Il campo del nome è obbligatorio",
    text37: "Il campo del cognome è obbligatorio",
    text38: "Il campo del genere è obbligatorio",
    text39: "Il campo della data di nascita è obbligatorio",
    text40: "Il campo del telefono è obbligatorio",
    text41: "Il campo della data di soggiorno è obbligatorio",
    text42: "Il campo dell'email è obbligatorio",
    text43: "Il campo del paese è obbligatorio",
    text44: "Il campo del tipo di documento è obbligatorio",
    text45: "Il campo del numero del documento è obbligatorio",
    text46: "Devi accettare i termini e le condizioni.",
    text47: "Invio dei dati del check-in in corso, attendi...",
    text48: "Caricamento...",
    text49: "check-in completato con successo.",
    text50: "Clicca qui per vedere tutti i nostri servizi disponibili in hotel",
    text51: "Inserisci il nome",
    text52: "Inserisci il cognome",
    text53: "Paese",
    text54: "Errore",
    text55: "Inserisci l'indirizzo email",

    // Corrections
    p1: "Data del check-in",
    p2: "Data del check-out",
    p3: "Data di rilascio del documento",
    p4: "",
    p5: "",
    p6: "",
    p7: "",
    p8: "",
};
